import { JuloUpdateEntry } from "./types"

export const allJobsTableEntry: JuloUpdateEntry = {
  slug: "2026-09-29-all-jobs-table",
  date: "2026-09-29",
  title: "Alla jobb i en tabell med egna vyer",
  description:
    'I [Översikten](/) har "Senast ändrade" ersatts av "Alla jobb" – en tabell där varje jobb är en rad.\n\nNi kan skapa flera vyer, till exempel "Att fakturera" eller "Akut", och i varje vy välja vilka kolumner som ska visas, hur jobben ska sorteras och vad som ska filtreras bort. Filter kan kombineras med "alla villkor" eller "något villkor", och ni kan samla flera villkor i en filtergrupp.\n\nVyerna delas av alla i verkstaden, så ändringar ni gör syns direkt för era kollegor. Dubbelklicka på en vy för att byta namn, eller använd de tre prickarna för att duplicera eller ta bort den. Dra vyerna för att ändra ordning.',
  images: [
    {
      src: "/julo-updates/2026-09-29-all-jobs-table/1-alla-jobb.png",
      alt: 'Översikten med kortet "Alla jobb" valt. Till höger visas vyerna Alla jobb, Att fakturera, Leasing och Akut, knapparna Filter, Sortera och Kolumner samt en tabell med kolumnerna ID, Status, Kund och Cykelmärke.',
    },
  ],
}
